<div class="simyo-wifi5g-modal">
    <button type="button" class="simyo-wifi5g-modal__close" aria-label="Cerrar" (click)="dismiss()">
        <img src="./assets/img/times2.svg" alt="" width="18" height="18">
    </button>

    <div class="simyo-wifi5g-modal__header text-center">
        <img
            src="./assets/img/cell_tower.svg"
            alt=""
            class="simyo-wifi5g-modal__tower"
            width="32"
            height="32"
        >
        <h5 class="simyo-wifi5g-modal__title">Aún no disponemos de fibra en tu zona</h5>
    </div>

    <div class="simyo-wifi5g-modal__address" *ngIf="address">
        {{ address }}
    </div>

    <div class="simyo-wifi5g-modal__offer">
        <div class="simyo-wifi5g-modal__offer-visual">
            <img
                src="./assets/img/wifi5G.svg"
                alt="Router WiFi 5G"
                class="simyo-wifi5g-modal__router"
            >
        </div>

        <div class="simyo-wifi5g-modal__offer-copy">
            <h6 class="simyo-wifi5g-modal__subtitle">
                ¡No te preocupes! Tenemos la solución perfecta para ti
            </h6>
            <ul class="simyo-wifi5g-modal__benefits">
                <li *ngFor="let benefit of benefits">
                    <span class="simyo-wifi5g-modal__check" aria-hidden="true">
                        <img src="./assets/img/check.svg" alt="" width="12" height="12">
                    </span>
                    <span>{{ benefit }}</span>
                </li>
            </ul>
            <button type="button" class="btn btn-black simyo-wifi5g-modal__cta" (click)="hireWifi5g()">
                Contratar WiFi 5G
            </button>
            <p class="simyo-wifi5g-modal__footer">
                ¿Dirección incorrecta?
                <a href="#" class="simyo-wifi5g-modal__modify" (click)="$event.preventDefault(); modifyAddress()">Modificar</a>
            </p>
        </div>
    </div>
</div>
